<div class="media-team-links-wrapper">
	<a *ngFor="let team of sortedTeams" class="theme-header-txt media-team-link text-hover-none" uiSref="portal.media" [uiParams]="{team: team.id}" [title]="team.name">
		<span class="media-team-link-logo" [ngStyle]="{'background-color': team.thumbnailUri ? 'transparent': team.bgColor	}">
				<img *ngIf="team.thumbnailUri" [src]="team.thumbnailUri" [alt]="'ThumbnailForAria' | translate : { '0': team.name }" (error)="team.thumbnailUri = undefined"/>
		</span>
		<span [ngClass]="{'media-team-link-name': !team.thumbnailUri }">{{ team.name }}</span>
	</a>
</div>
